import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=656a7bc4&scoped=true"
import script from "./DictList.vue?vue&type=script&lang=js"
export * from "./DictList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a7bc4",
  null
  
)

export default component.exports